// src/utils/cartUtils.ts
export const addToCart = (productId: number) => {
  const stored = localStorage.getItem("cart");
  let cart: number[] = stored ? JSON.parse(stored) : [];

  if (!cart.includes(productId)) {
    cart.push(productId);
    localStorage.setItem("cart", JSON.stringify(cart));

     // 🔥 EVENT TRIGGERN
    window.dispatchEvent(new Event("cartUpdated"));
  }
};

export const removeFromCart = (productId: number) => {
  const stored = localStorage.getItem("cart");
  let cart: number[] = stored ? JSON.parse(stored) : [];

  cart = cart.filter((id) => id !== productId);
  localStorage.setItem("cart", JSON.stringify(cart));
};

export const getCart = (): number[] => {
  const stored = localStorage.getItem("cart");
  return stored ? JSON.parse(stored) : [];
};

export const clearCart = () => {
  localStorage.removeItem("cart");
  window.dispatchEvent(new Event("cartUpdated"));
};